class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* Coupon fix: the original check only looked at cart-level discounts, so codes that apply
   to specific products/collections (line-level) were wrongly reported as invalid.
   This version also checks line-level discounts and the cart total. */
(function () {
  function snap(cart) {
    var items = cart.items || [];
    return {
      total: cart.total_price,
      cartLevel: (cart.cart_level_discount_applications || []).length,
      lineLevel: items.reduce(function (n, i) { return n + (i.line_level_discount_allocations || []).length; }, 0)
    };
  }
  window.milopleApplyDiscount = async function () {
    var input = document.getElementById('discount-code');
    var errorEl = document.getElementById('discount-error');
    var applyBtn = document.getElementById('apply-discount');
    if (!input || !errorEl || !applyBtn) return;
    var code = input.value.trim();
    if (!code) return;
    errorEl.textContent = '';
    applyBtn.disabled = true;
    try {
      var before = snap(await (await fetch('/cart.js')).json());
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: code }) });
      var after = snap(await (await fetch('/cart.js')).json());
      var applied = after.cartLevel > before.cartLevel || after.lineLevel > before.lineLevel || after.total < before.total;
      if (!applied) {
        errorEl.textContent = 'Invalid coupon code';
        applyBtn.disabled = false;
        return;
      }
      await milopleRefreshCartDrawer();
    } catch (err) {
      errorEl.textContent = 'Something went wrong. Please try again.';
      applyBtn.disabled = false;
    }
  };
})();

/* Line-total price fix: the VAT Exemption app rewrites every element with the class "price"
   to the VAT-relief amount, which made the struck-through original line total show the same
   value as the discounted total (e.g. 90.00 and 90.00). Line totals in the cart drawer use a
   different class so the app leaves them alone; styling is kept identical. */
(function () {
  var style = document.createElement('style');
  style.textContent = '#CartDrawer .cart-item__totals .line-price{font-size:15px;font-weight:700;white-space:nowrap}';
  document.head.appendChild(style);
  function fix() {
    var els = document.querySelectorAll('#CartDrawer .cart-item__totals .cart-item__price-wrapper .price');
    for (var i = 0; i < els.length; i++) {
      els[i].classList.remove('price');
      els[i].classList.add('line-price');
    }
  }
  fix();
  new MutationObserver(fix).observe(document.body, { childList: true, subtree: true });
})();
